var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8C4.13181 8 3.83333 8.29848 3.83333 8.66667V10.6667C3.09695 10.6667 2.5 11.2636 2.5 12V12.6667C2.5 13.403 3.09695 14 3.83333 14H13.1667C13.903 14 14.5 13.403 14.5 12.6667V12C14.5 11.2636 13.903 10.6667 13.1667 10.6667V8.66667C13.1667 8.29848 12.8682 8 12.5 8C12.1318 8 11.8333 8.29848 11.8333 8.66667V10.6667H10.5V8.66667C10.5 8.29848 10.2015 8 9.83333 8C9.46514 8 9.16667 8.29848 9.16667 8.66667V10.6667H7.83333V8.66667C7.83333 8.29848 7.53486 8 7.16667 8C6.79848 8 6.5 8.29848 6.5 8.66667V10.6667H5.16667V8.66667C5.16667 8.29848 4.86819 8 4.5 8Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.94981C2.5 4.38208 2.85987 3.87669 3.39655 3.69071L8.06322 2.07353C8.34614 1.97549 8.65386 1.97549 8.93678 2.07353L13.6034 3.69071C14.1401 3.87669 14.5 4.38208 14.5 4.94981V5.33403C14.5 6.07003 13.903 6.66667 13.1667 6.66667H3.83333C3.09695 6.66667 2.5 6.07003 2.5 5.33403V4.94981Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f8d40807.svg";
export { ForwardRef as ReactComponent };